export default __webpack_public_path__ + "static/media/0xcf749620571a3920a27cd8eef17daa1db7c93c4c.17b22b1e.png";